import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../../api/useApi";
import {
    GetDepartmentIdentityByIdRequest,
    GetDepartmentIdentityByIdResponse,
    type DepartmentIdentity,
    type IReturn,
    type ResponseStatus,
} from "src/api/Tmd.dtos";

const getData = (
    response?: SWRResponse<GetDepartmentIdentityByIdResponse, GetDepartmentIdentityByIdResponse>,
) => response?.data?.departmentIdentity;
const getError = (
    response?: SWRResponse<GetDepartmentIdentityByIdResponse, GetDepartmentIdentityByIdResponse>,
) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (
    response?: SWRResponse<GetDepartmentIdentityByIdResponse, GetDepartmentIdentityByIdResponse>,
) => ({});

const useDepartmentIdentityById = (
    id?: number | null,
    configuration?:
        | SWRConfiguration<
              GetDepartmentIdentityByIdResponse,
              GetDepartmentIdentityByIdResponse
          >
        | null,
) => {
    const getRequest = useMemo(() => {
        if (!id) return undefined;

        return (): IReturn<GetDepartmentIdentityByIdResponse> =>
            new GetDepartmentIdentityByIdRequest({ id });
    }, [id]);

    return useApi("get", getRequest, { getData, getError, getAdditionalState }, configuration ?? undefined);
};

export default useDepartmentIdentityById;
